module.exports = __webpack_public_path__ + "static/img/technologybg.02a67eb5.png";